import { Edit as ReactAdminEdit, SimpleForm, TextInput } from "react-admin";

export const Edit: React.FC = () => (
    <ReactAdminEdit>
        <SimpleForm>
            <TextInput source="Name" />
        </SimpleForm>
    </ReactAdminEdit>
);
